import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import {APP_BASE_HREF} from '@angular/common';

import { AppComponent } from './app.component';
import {environment} from "../environments/environment";
import {firebaseConfig} from "../environments/environment";

import {AngularFireModule} from "@angular/fire"
import {AngularFireDatabase} from "@angular/fire/database"



import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/switchMap';

import {RouterModule} from "@angular/router";
import {routerConfig} from "./router.config";

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { TopMenuComponent } from './top-menu/top-menu.component';
import { SafeUrlPipe } from './shared/security/safe-url.pipe';
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';

//import {AuthService} from "./shared/security/auth.service";
import {AuthGuard} from "./shared/security/auth.guard";
import {ClubsComponent } from './clubs/clubs.component';
import {ClubsService} from "./shared/model/clubs.service";
import {UserService} from "./shared/model/user.service";
import {FieldsService} from "./shared/model/fields.service";
import {PsusService} from "./shared/model/psus.service";
import {CpusService} from "./shared/model/cpus.service";

import { ModalWindowComponent } from './modal-window/modal-window.component';
import { UsersListComponent } from './users-list/users-list.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { UserAddComponent } from './user-add/user-add.component';
import { FieldsListComponent } from './fields-list/fields-list.component';
import { FieldAddComponent } from './field-add/field-add.component';
import { FieldDetailComponent } from './field-detail/field-detail.component';
import { CpuAddComponent } from './cpu-add/cpu-add.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { CpuDetailComponent } from './cpu-detail/cpu-detail.component';
import { PsuAddComponent } from './psu-add/psu-add.component';
import { PsuDetailComponent } from './psu-detail/psu-detail.component';
import { LightingComponent } from './lighting/lighting.component';
import {CommandService} from "./shared/model/command.service";
import { LightingDetailComponent } from './lighting-detail/lighting-detail.component';
import { ClubAddComponent } from './club-add/club-add.component';
import {HomeComponent} from "./home/home.component";
import {AngularFireAuthModule} from "@angular/fire/auth";
import {AngularFireDatabaseModule} from "@angular/fire/database";
import {AuthService} from "./shared/security/auth.service";
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SettingsComponent } from './settings/settings.component';
import { LogoutComponent } from './logout/logout.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { ErrorComponent } from './error/error.component';
import {ErrorService} from "./shared/model/error.service";
import {ReversePipe} from "./shared/pipes/ReversePipe";
import { ErrorDetailComponent } from './error-detail/error-detail.component';
import { PsuPoweronComponent } from './psu-poweron/psu-poweron.component';
import { ReservationsComponent } from './reservations/reservations.component';
import {ReservationsService} from "./shared/model/reservations.service";
import { PsuFactoryPowerComponent } from './psu-factory-power/psu-factory-power.component';
import { Lighting2Component } from './lighting2/lighting2.component';
import { AgendaComponent } from './agenda/agenda.component';
import { AgendaAddComponent } from './agenda-add/agenda-add.component';
import {SortPipe} from "./shared/pipes/sort.pipe";
import { AgendaDetailComponent } from './agenda-detail/agenda-detail.component';
import { AgendaUpdateComponent } from './agenda-update/agenda-update.component';
import { ReservationsAddComponent } from './reservations-add/reservations-add.component';
import { PsuAddressComponent } from './psu-address/psu-address.component';
import {LastusedService} from "./shared/model/lastused.service";
import { GenerateparamsComponent } from './generateparams/generateparams.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TopMenuComponent,
    SafeUrlPipe,
    LoginComponent,
    RegisterComponent,
    ClubsComponent,
    ModalWindowComponent,
    UsersListComponent,
    UserDetailComponent,
    UserAddComponent,
    FieldsListComponent,
    FieldAddComponent,
    FieldDetailComponent,
    CpuAddComponent,
    ConfirmationComponent,
    CpuDetailComponent,
    PsuAddComponent,
    PsuDetailComponent,
    LightingComponent,
    LightingDetailComponent,
    ClubAddComponent,
    ResetPasswordComponent,
    SettingsComponent,
    LogoutComponent,
    UserInfoComponent,
    ErrorComponent,
    ReversePipe,
    ErrorDetailComponent,
    PsuPoweronComponent,
    ReservationsComponent,
    PsuFactoryPowerComponent,
    Lighting2Component,
    AgendaComponent,
    AgendaAddComponent,
    SortPipe,
    AgendaDetailComponent,
    AgendaUpdateComponent,
    ReservationsAddComponent,
    PsuAddressComponent,
    GenerateparamsComponent
  ],
  imports: [
      BrowserModule,
      AngularFireModule.initializeApp(firebaseConfig),
      AngularFireDatabaseModule,
      AngularFireAuthModule,
      RouterModule.forRoot(routerConfig),
      FormsModule,
      ReactiveFormsModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (HttpLoaderFactory),
          deps: [HttpClient]
        }
      }),
      HttpClientModule
    ],
    providers: [{ provide: LOCALE_ID, useValue: 'de' }, {provide: APP_BASE_HREF, useValue: '/'}, SortPipe, AuthGuard, CpusService, PsusService, UserService, ClubsService, FieldsService, AuthService, CommandService, ErrorService, ReservationsService, LastusedService],
    bootstrap: [AppComponent]
})
export class AppModule { }


